import * as React from 'react';
const SvgCreative = (props) => (
  <svg viewBox="0 0 120 125" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m44.14 98.14.06 11.145c.437 7.307 8.067 13.098 16.689 13.098 8.62 0 15.686-5.828 16.123-13.135V98.023l.157-3.557c.025-.176.66-4.378 6.037-8.622.028-.022.055-.044.081-.068L85 84.225l.02-.02c7.154-6.729 11.095-15.817 11.095-25.588 0-19.45-15.968-35.273-35.596-35.273-19.627 0-35.595 15.823-35.595 35.273 0 9.76 4.137 19.174 11.35 25.828l.06.052 1.594 1.325s.02.015.029.024c5.373 4.244 6.012 8.444 6.034 8.61l.15 3.685v-.002ZM44.722 98.431l31.026.014M44.722 106.441l31.026.013M46.951 114.786l27.125.013M60.116 12.97V2.384M118 57.813h-10.688M110.541 31.312l-9.406 5.028M101.575 81.202l9.98 3.783M88.499 8.797l-5.145 9.281M2 58.167h10.685M8.362 30.675l9.406 5.026M17.7 79.985 7.716 83.77M31.694 8.797l5.143 9.281"
      stroke="#231F20"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m66.7 36.531-24.684 24.63 16.364 1.114-8.056 21.034 27.857-27.37-17.548-1.197 6.067-18.21Z"
      stroke="#231F20"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgCreative;
